interface ProgressBarDescriptor
{
	name: string;
	value: number;
	text: string;
	id?: string;
	min?: number;
	max?: number;
	context?: string;
	striped?: boolean;
	animated?: boolean;
}

class ProgressBar
{
	protected element: HTMLElement;
	protected body: HTMLElement;

	constructor(
		descriptor: ProgressBarDescriptor,
	)
	{
		this.element = document.createElement( 'div' );
		$( this.element ).addClass( 'progress' );

		this.body = document.createElement( 'div' );
		$( this.body ).addClass( 'progress-bar' );

		$( this.body ).attr( 'role', 'progressbar' );

		if ( descriptor.id )
		{
			$( this.body ).attr( 'id', descriptor.id );
		}
		$( this.body ).attr( 'name', descriptor.name );

		$( this.body ).attr( 'aria-valuenow', descriptor.value );

		if ( descriptor.min )
		{
			$( this.body ).attr( 'aria-valuemin', descriptor.min );
		}
		if ( descriptor.max )
		{
			$( this.body ).attr( 'aria-valuemax', descriptor.max );
		}
		$( this.body ).attr( 'style', 'width: ' + descriptor.value + '%;' );
		$( this.body ).html( descriptor.text );

		$( this.body ).addClass( 'progress-bar-' + descriptor.context );

		if ( descriptor.striped )
		{
			$( this.body ).addClass( 'progress-bar-striped' );

		 if ( descriptor.animated )
			{
				$( this.body ).addClass( 'active' );
			}

		}

		$( this.element ).append( this.body );
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}
